module.exports = __webpack_public_path__ + "img/sec13_1mob.76ecc5da.png";